import { ButtonLinkWithIcon } from '@blueprint/ui';
import { Heading1 } from '@blueprint/heading';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ListingPreviewContainer } from 'listing-details/components/shared/ListingPreview/ListingPreview.styles';
import Wrapper from 'shared/components/Content/Wrapper';
import { CompactListingPreviewCard } from 'listing-details/components/shared/ListingPreview/CompactListingPreview/CompactListingPreview.styles';

const SECONDARY_COLUMN_WIDTH_MD = '50%';
const SECONDARY_COLUMN_WIDTH_LARGE = '30rem';
const SECONDARY_COLUMN_WIDTH_EXTRA_LARGE = '35rem';

export const ContactPageContainer = styled('div')(
    ({ theme: { colors } }) => css`
        background-color: ${colors['graphic-background-accent-light']};
    `
);

export const NavigationLink = styled(ButtonLinkWithIcon)(`
    padding-left: 0;
`);

export const ContactPrimary = styled('div')(
    ({ theme: { fontSizes, mq, spacing } }) => css`
        position: relative;
        padding-top: ${spacing['16px']};

        ${Heading1} {
            margin-bottom: ${spacing['16px']};

            ${mq.medium} {
                margin-bottom: ${spacing['24px']};
            }

            ${mq.large} {
                font-size: ${fontSizes['6']};
            }
        }

        ${CompactListingPreviewCard} {
            margin-bottom: ${spacing['16px']};
        }

        ${mq.medium} {
            padding-right: ${SECONDARY_COLUMN_WIDTH_MD};

            ${ListingPreviewContainer} {
                position: absolute;
                right: 0;
                top: 0;
                width: calc(${SECONDARY_COLUMN_WIDTH_MD} - ${spacing['16px']});
            }
        }
        ${mq.large} {
            padding-right: ${SECONDARY_COLUMN_WIDTH_LARGE};

            ${ListingPreviewContainer} {
                width: calc(${SECONDARY_COLUMN_WIDTH_LARGE} - 7.875rem);
            }
        }
        ${mq.extraLarge} {
            padding-right: ${SECONDARY_COLUMN_WIDTH_EXTRA_LARGE};

            ${ListingPreviewContainer} {
                width: calc(${SECONDARY_COLUMN_WIDTH_EXTRA_LARGE} - 7.875rem);
            }
        }
    `
);

export const Layout = styled(Wrapper)(
    css`
        display: block;
    `
).withComponent('main');
